// extracted by mini-css-extract-plugin
module.exports = {"couponDateField":"CouponList_couponDateField__3kK8P","elementHidden":"CouponList_elementHidden__6F4pr","dateDisabledText":"CouponList_dateDisabledText__2-VP7"};